import React, { useContext } from "react";
import * as T from "./types";
import * as S from "./styles";
import D from '@assets/themes/dimensions';
import EyeDropperIcon from "@assets/icons/eyeDropperIcon";
import { Context } from "@routes/private/Editor/Context";
import { drawEyeDropperPreview } from "@utils/render";

const PREVIEW_PIXEL_DIM = {width: 10, height: 10};
const HALF_PIXEL_DIM = {width: PREVIEW_PIXEL_DIM.width / 2, height: PREVIEW_PIXEL_DIM.height / 2};
const PREVIEW_DIM = {width: 100, height: 100};

const EyeDropper: React.FC<T.IProps> = (props) => {

  const { stageRef } = useContext(Context);
  const canvasRef = React.useRef<HTMLCanvasElement>(null);

  const [coors, setCoors] = React.useState({x: 0, y: 0});
  const [color, setColor] = React.useState<string>();

  const movingEyeDropper = (e: MouseEvent) => {
    const ctx = stageRef?.current?.getLayers()[0]?.getContext();
    const dpr = window.devicePixelRatio;
    const previewCtx = canvasRef.current?.getContext('2d');
    if (ctx) {
      const detectedPoint = {x: (e.pageX - D.TOOL_BAR_WIDTH) * dpr, y: (e.pageY - D.APP_BAR_HEIGHT - D.COMMAND_BAR_HEIGHT) * dpr};
      const data = ctx.getImageData(detectedPoint.x - HALF_PIXEL_DIM.width - 1, detectedPoint.y - HALF_PIXEL_DIM.height - 1, PREVIEW_PIXEL_DIM.width + 1, PREVIEW_PIXEL_DIM.height + 1).data;
      if (previewCtx) setColor(drawEyeDropperPreview(previewCtx, data, PREVIEW_PIXEL_DIM, PREVIEW_DIM));
      setCoors({x: e.pageX, y: e.pageY});
    }
  }

  const finishPickingColor = () => {
    props.selectColor(color);
  }

  React.useEffect(() => {
    document.addEventListener('mousemove', movingEyeDropper);
    return () => document.removeEventListener('mousemove', movingEyeDropper);
  }, []);

  const cellWidth = PREVIEW_DIM.width / PREVIEW_PIXEL_DIM.width;
  const cellHeight = PREVIEW_DIM.height / PREVIEW_PIXEL_DIM.height;

  return(
    <S.Root>
      <S.EyeDropperContainer
        style={{
          ...props.style,
          left: `${coors.x - 200}px`,
          top: `${coors.y - 216}px`,
        }}
        onClick={finishPickingColor}
      >
        <EyeDropperIcon
          pickedColor={color}
        />
      </S.EyeDropperContainer>
      <S.Preview
        displayValue={color ? 'auto' : 'none'}
      >
        <S.CanvasContainer>
          <S.Canvas
            ref={canvasRef}
            width={PREVIEW_DIM.width}
            height={PREVIEW_DIM.height}
          />
          <S.Grid
            cellWidth={cellWidth}
            cellHeight={cellHeight}
          />
          <S.ColorStroke
            topValue={PREVIEW_DIM.height / 2 - PREVIEW_PIXEL_DIM.height / 2}
            rightValue={PREVIEW_DIM.width / 2 - PREVIEW_PIXEL_DIM.width / 2 - 1}
            cellWidth={cellWidth}
            cellHeight={cellHeight}
          />
        </S.CanvasContainer>
        <S.Label
          rightValue={(PREVIEW_DIM.width - 70) / 2}
        >
          {color?.toUpperCase()}
        </S.Label>
      </S.Preview>
    </S.Root>
  );
}

export default EyeDropper;